import { database, ref, get, set, remove } from "../config/firebase";

const NODE_COMMUNITY_LAUNCH = "communityLaunchNotifications";

export interface CommunityLaunchSubscription {
  email: string;
  createdAt: number;
}

export async function subscribeToCommunityLaunch(
  userId: string,
  email: string
): Promise<void> {
  if (!database || !email?.trim()) return;
  const nodeRef = ref(database, `${NODE_COMMUNITY_LAUNCH}/${userId}`);
  await set(nodeRef, {
    email: email.trim(),
    createdAt: Date.now(),
  });
}

export async function unsubscribeFromCommunityLaunch(
  userId: string
): Promise<void> {
  if (!database) return;
  const nodeRef = ref(database, `${NODE_COMMUNITY_LAUNCH}/${userId}`);
  await remove(nodeRef);
}

export async function getCommunityLaunchSubscription(
  userId: string
): Promise<CommunityLaunchSubscription | null> {
  if (!database) return null;
  const nodeRef = ref(database, `${NODE_COMMUNITY_LAUNCH}/${userId}`);
  const snapshot = await get(nodeRef);
  const data = snapshot.val();
  if (!data || typeof data.email !== "string") return null;
  return {
    email: data.email,
    createdAt: typeof data.createdAt === "number" ? data.createdAt : 0,
  };
}
